import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntUnitMeasurementFilter } from "../../../../models/filters/unitMeasurementFilter";
import { EntUnitMeasurement } from "../../../../models/handBooks/unitMeasurement";
import { useLazyGetUnitMeasurementListQuery } from "../../../../redux/api/handBooksApi/unitMeasurementApi";
import { AddUnitMeasurementModal } from "./AddUnitMeasurementModal";
import { useUnitMeasurement } from "./useUnitMeasurement";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name
}

export const UnitMeasurement = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [form] = useForm();
  const { t } = useTranslation()
  const [selectedUnitMeasurement, setSelectedUnitMeasurement] = useState<EntUnitMeasurement>(new EntUnitMeasurement());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddUnitMeasurement, onEditUnitMeasurement, onDeleteUnitMeasurement } = useUnitMeasurement(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetUnitMeasurementListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setCurrentPage,
	setFetching,
	setFilter
  } = useGetDataOnScroll<EntUnitMeasurement, EntUnitMeasurementFilter>({
	initialFilter: new EntUnitMeasurementFilter(),
	query: getData
  });

  const openAddModal = (item: EntUnitMeasurement) => {
	setSelectedUnitMeasurement(item);
	setShowModal(true);
  }
  const setEntityFromFields = (): EntUnitMeasurementFilter => {
	let item: EntUnitMeasurementFilter = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteUnitMeasurement(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.units_of_measurement') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntUnitMeasurement)
		} }>
		  { t('handbooks.units_of_measurement.add_units_of_measurement') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick }
										onReset={ () => {
										  clearFields();
										  searchHandleClick()
										} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }

		width={ 800 }
	  />
	  <AddUnitMeasurementModal
		unitMeasurement={ selectedUnitMeasurement }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedUnitMeasurement.id !== 0 ? onEditUnitMeasurement : onAddUnitMeasurement }
	  />
	  { contextHolder }
	</>
  )
}
